import React, { useState, useEffect, useMemo } from "react";

function CountDownTimer() {
  const [timeRemaining, setTimeRemaining] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  }); // set initial time remaining to 0
  const targetTime = useMemo(() => {
    const now = new Date();
    const targetTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      12,
      31
    );
    // set the target time to today at 12.31 PM
    if (now.getHours() >= 12 && now.getMinutes() >= 31) {
      targetTime.setDate(targetTime.getDate() + 1); // if current time is past 12:31 PM, set target time to tomorrow at 12:31 PM
    }
    return targetTime;
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      const timeDiff = targetTime - new Date(); // calculate the difference between target time and current time
      const hours = Math.floor(timeDiff / 1000 / 60 / 60); // calculate hours remaining
      const minutes = Math.floor((timeDiff / 1000 / 60) % 60); // calculate minutes remaining
      const seconds = Math.floor((timeDiff / 1000) % 60); // calculate seconds remaining
      setTimeRemaining({ hours, minutes, seconds }); // set time remaining object
    }, 1000);

    return () => clearInterval(interval); // clear interval when component unmounts
  }, [targetTime]);

  return (
    <div className="items-center">
      {timeRemaining.hours > 0 ||
        timeRemaining.minutes > 0 ||
        timeRemaining.seconds > 0 ? (
        <h1 className="text-center">{`${timeRemaining.hours
          .toString()
          .padStart(2, "0")}:${timeRemaining.minutes
            .toString()
            .padStart(2, "0")}:${timeRemaining.seconds
              .toString()
              .padStart(2, "0")}`}</h1>
      ) : (
        <h1>Loading...</h1>
      )}
    </div>
  );
}

export default CountDownTimer;
